import React from 'react';
import { Card, Stack, Typography } from '@mui/material';
import { theme } from '../../constants/theme';
import { useThemeContext } from '../../hook/useThemeManager';
import { IAudition } from '../../types/global/helper';
import { FONT_ENUM } from '../../types/global/fonts.types';
import CalendarIcon from '../CustomSVGIcons/CalendarIcon';
import Payments from '@mui/icons-material/Payments';
import { TextWithIcon } from '../TextWithIcon/TextWithIcon';
import { formatWithOrdinal, getPayRangeText } from '../../utils/AppUtils';

const AuditionDetails: React.FC<{ audition: IAudition }> = ({ audition }) => {
    const { themeStyle } = useThemeContext();
    const roles = audition.roles?.filter(role => role != null) || [];
    const payRangeText = getPayRangeText(roles);

    return (
        <Stack>
            {/* Dates & Location */}
            <TextWithIcon
                icon={<CalendarIcon fill={theme[themeStyle].tag_white} height="20px" width="20px" />}
                text=" Dates & Location"
            />
            <Card
                sx={{
                    width: '100%',
                    borderRadius: 2,
                    overflow: 'visible',
                    my: 2,
                    p: 1,
                    height: '100%',
                    backgroundColor: 'rgb(229,244,245)',
                }}>
                <Stack height="100%" direction="column" justifyContent="space-between">
                    <Stack
                        sx={{
                            backgroundColor: 'rgb(229,244,245)',
                            borderRadius: 1,
                            padding: '4px 8px',
                            width: '100%',
                            my: 1,
                        }}>
                        <Typography style={{ fontFamily: FONT_ENUM.MAIN_MEDIUM, fontSize: 14 }}>
                            Starts {formatWithOrdinal(audition.job_start_date, false)} in{' '}
                            {audition.shoot_location?.address || 'Unknown Location'}
                        </Typography>
                    </Stack>
                </Stack>
            </Card>

            {/* Compensation */}
            {payRangeText && (
                <>
                    <TextWithIcon
                        icon={<Payments sx={{ fontSize: 18, color: theme[themeStyle].tag_white }} />}
                        text="Compensation"
                    />
                    <Card
                        sx={{
                            width: '100%',
                            borderRadius: 2,
                            overflow: 'visible',
                            my: 2,
                            p: 1,
                            height: '100%',
                            backgroundColor: 'rgb(229,244,245)',
                        }}>
                        <Stack height="100%" direction="column" justifyContent="space-between">
                            <Stack
                                sx={{
                                    backgroundColor: 'rgb(229,244,245)',
                                    borderRadius: 1,
                                    padding: '4px 8px',
                                    width: '100%',
                                    my: 1,
                                }}>
                                <Typography style={{ fontFamily: FONT_ENUM.MAIN_BOLD, fontSize: 14 }}>
                                    {payRangeText}{' '}
                                    {`${
                                        audition.reward_frequency && audition.reward_frequency !== 'none'
                                            ? '/ ' + audition.reward_frequency
                                            : ''
                                    }`}
                                </Typography>
                            </Stack>
                        </Stack>
                    </Card>
                </>
            )}
        </Stack>
    );
};

export { AuditionDetails };
